import React, { FunctionComponent } from 'react'
import { Tooltip } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckDouble, faCheck } from '@fortawesome/free-solid-svg-icons'
import ProfileAvatar from '../../helpers/ProfileAvatar/ProfileAvatar'
import './singleMessage.css'
import moment from 'moment'

type Props = {
	body: string
	fromCurrentUser: boolean
	avatarURL: string
	time: Date
	timezone: string
	messageReadStatus: boolean
}

const SingleMessage: FunctionComponent<Props> = (props) => {
	const { body, fromCurrentUser, avatarURL, time, timezone, messageReadStatus } = props

	return (
		<div className={`single-message-wrapper ${fromCurrentUser ? 'single-message-wrapper-right' : ''}`}>
			<span className="single-message-time">
				{moment.tz(time, timezone).format('MMM DD, YY, hh:mm')} {timezone}
			</span>
			<ProfileAvatar
				size={35}
				src={avatarURL}
				className={`${fromCurrentUser ? 'single-message-avatar-current' : ''}`}
			/>
			<div className={`single-message-body ${fromCurrentUser ? 'single-message-body-current' : ''}`}>{body}</div>
			{fromCurrentUser && (
				<div className="message-status-icon">
					<Tooltip title={messageReadStatus ? 'Seen' : 'Sent, Unread'} placement="rightTop">
						<FontAwesomeIcon
							icon={messageReadStatus ? faCheckDouble : faCheck}
							color={messageReadStatus ? '#52c41a' : '#8C8C8C'}
						/>
					</Tooltip>
				</div>
			)}
		</div>
	)
}

export default SingleMessage
